import { GridCellProps } from "@progress/kendo-react-grid";
import { GridColumn } from "@progress/kendo-react-grid/dist/npm/GridColumn";
import BooleanAsYesNoCell from "../../../Grid/BooleanAsYesNoCell";
import BooleanToTextCell from "../../../Grid/BooleanToTextCell";
import { columnForField, defaultColumnWidth } from "../../../Grid/columnForField";
import { kendoDateCell } from "../../../Layout/Grid/Cell/DateCell";
import { RelationProjectStateColumnMenu } from "../../ColumnMenus/RelationProjectStateColumnMenu";
import { SpdrRelationUpdateModeColumnMenu } from "./SpdrRelationUpdateModeColumnMenu";
import { SpdrOverviewItem } from "./SpdrOverviewItem";
import { GridRowClickProps } from "../../../Layout/Grid/GridRowClickProps";
import { ClassificationColumnMenu } from "../../ColumnMenus/ClassificationColumnMenu";
import { MilkrunColumnMenu } from "../../ColumnMenus/MilkrunColumnMenu";
import { EnumerationCell } from "../../../Layout/Grid/Cell/Default/EnumCell";
import { relationUpdateModeAsString } from "../../RelationUpdateMode";
import { relationProjectStateAsString } from "../../RelationProjectState";
import { GRID_SELECTED_FIELD } from "../../../Grid/Selectable/GridSelection";
import { InScopeOutOfScopeColumnMenu } from "../../../Layout/Grid/Filter/InScopeOutOfScopeColumnMenu";
import { ValueOrDashCell } from "../../../Grid/ValueOrDashCell";
import { YesNoColumnMenu } from "../../../Layout/Grid/Filter/YesNoColumnMenu";
import { MultiSelectCheckboxProps } from "../../../Grid/Selectable/MultiSelectCheckboxProps";
import { customDecimalFilterCell } from "../../../Layout/Filter/CustomDecimalFilterCell";

export function SpdrOverviewColumns({
  dataResult,
  selectedState,
  onRowClick,
}: MultiSelectCheckboxProps & GridRowClickProps) {
  const relationProjectStateEnumCell = (props: GridCellProps) => (
    <EnumerationCell {...props} mapping={relationProjectStateAsString} onRowClick={onRowClick} />
  );

  const relationUpdateModeEnumCell = (props: GridCellProps) => (
    <EnumerationCell {...props} mapping={relationUpdateModeAsString} onRowClick={onRowClick} />
  );

  const inScopeCell = (props: GridCellProps) => (
    <BooleanToTextCell {...props} trueTranslation="In Scope" falseTranslation="Out of Scope" />
  );

  const exceptionRequiredCell = (props: GridCellProps) => <BooleanAsYesNoCell {...props} />;

  return [
    <GridColumn
      key="SelectHeader"
      field={GRID_SELECTED_FIELD}
      width="44px"
      resizable={false}
      filterable={false}
      headerSelectionValue={dataResult.data.findIndex((item) => !selectedState[item.Id]) === -1}
      locked
    />,
    columnForField<SpdrOverviewItem>("ProjectState", {
      title: "Status",
      cell: relationProjectStateEnumCell,
      columnMenu: RelationProjectStateColumnMenu,
      width: defaultColumnWidth,
      hideFilterCell: true,
      locked: true,
    }),
    columnForField<SpdrOverviewItem>("SPDR", {
      title: "SPDR",
      width: defaultColumnWidth,
      locked: true,
    }),
    columnForField<SpdrOverviewItem>("SPR", {
      title: "SPR",
      width: defaultColumnWidth,
      locked: true,
    }),
    columnForField<SpdrOverviewItem>("SupplierGSDB", {
      title: "Supplier",
      width: defaultColumnWidth,
    }),
    columnForField<SpdrOverviewItem>("PlantGSDB", {
      title: "Plant",
      width: defaultColumnWidth,
    }),
    columnForField<SpdrOverviewItem>("DockCode", {
      title: "Dock",
      width: "125px",
    }),
    columnForField<SpdrOverviewItem>("Status", {
      title: "Update Mode",
      cell: relationUpdateModeEnumCell,
      columnMenu: SpdrRelationUpdateModeColumnMenu,
      width: defaultColumnWidth,
      hideFilterCell: true,
    }),
    columnForField<SpdrOverviewItem>("InScope", {
      title: "Scope",
      filter: "boolean",
      cell: inScopeCell,
      width: defaultColumnWidth,
      columnMenu: InScopeOutOfScopeColumnMenu,
      hideFilterCell: true,
    }),
    columnForField<SpdrOverviewItem>("ImplementationDate", {
      title: "Implementation Date",
      filter: "date",
      cell: kendoDateCell(onRowClick, "-"),
      width: "200px",
    }),
    columnForField<SpdrOverviewItem>("ModificationDate", {
      title: "Modification Date",
      filter: "date",
      cell: kendoDateCell(onRowClick, "-"),
      width: defaultColumnWidth,
    }),
    columnForField<SpdrOverviewItem>("SpdrClassification", {
      title: "SPDR Classification",
      width: defaultColumnWidth,
      columnMenu: ClassificationColumnMenu,
      cell: ValueOrDashCell,
      hideFilterCell: true,
    }),
    columnForField<SpdrOverviewItem>("TransportationMode", {
      title: "Transportation Mode",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("Milkrun", {
      title: "Milkrun",
      width: "125px",
      columnMenu: MilkrunColumnMenu,
      cell: ValueOrDashCell,
      hideFilterCell: true,
    }),
    columnForField<SpdrOverviewItem>("RouteControlType", {
      title: "Route Control Type",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ControlDepartment", {
      title: "Control Department",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ContingencyPlanningType", {
      title: "Contingency Planning Type",
      width: "225px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ProposedProjectId", {
      title: "Proposed Project ID",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ActiveProjectId", {
      title: "Active Project ID",
      width: defaultColumnWidth,
      filter: "numeric",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("LaunchBatch", {
      title: "Launch Batch",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("LaunchStatus", {
      title: "Launch Status",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("LaunchDate", {
      title: "Launch Date",
      filter: "date",
      cell: kendoDateCell(onRowClick, "-"),
      width: defaultColumnWidth,
    }),

    // Supplier
    columnForField<SpdrOverviewItem>("SupplierName", {
      title: "Supplier Name",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SupplierCity", {
      title: "Supplier City",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SupplierZipCode", {
      title: "Supplier Zip Code",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SupplierZipArea", {
      title: "Supplier Zip Area",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SupplierCountryName", {
      title: "Supplier Country",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("CollectionRegion", {
      title: "Collection Region",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("CmmsCountryCode", {
      title: "Country Code",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("CmmsAreaCode", {
      title: "Area Code",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),

    // Plant
    columnForField<SpdrOverviewItem>("PlantCode", {
      title: "Plant Code",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("PlantName", {
      title: "Plant Name",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("PlantCity", {
      title: "Plant City",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("PlantCountryName", {
      title: "Plant Country",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("PartDestination", {
      title: "Part Destination",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),

    // ODCs
    columnForField<SpdrOverviewItem>("FirstOdcInbound", {
      title: "Inbound Route 1st ODC",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FirstOdcShortName", {
      title: "1st ODC",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FirstOdcCarrierName", {
      title: "1st ODC Carrier Name",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FirstOdcCarrierGsdb", {
      title: "1st ODC Carrier GSDB",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FirstOdcCarrierBranch", {
      title: "1st ODC Carrier Branch",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FirstOdcArrivalDay", {
      title: "1st ODC Arrival Day",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FirstOdcEta", {
      title: "1st ODC ETA",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FirstOdcHandlingTime", {
      title: "1st ODC Handling Time",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FirstOdcOutboundDay", {
      title: "1st ODC Outbound Day",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FirstOdcEtd", {
      title: "1st ODC ETD",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FirstOdcTrainFerry", {
      title: "1st ODC Train / Ferry",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SecondOdcInbound", {
      title: "Inbound Route 2nd ODC",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SecondOdcShortName", {
      title: "2nd ODC",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SecondOdcCarrierName", {
      title: "2nd ODC Carrier Name",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SecondOdcCarrierGsdb", {
      title: "2nd ODC Carrier GSDB",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SecondOdcCarrierBranch", {
      title: "2nd ODC Carrier Branch",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SecondOdcArrivalDay", {
      title: "2nd ODC Arrival Day",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SecondOdcEta", {
      title: "2nd ODC ETA",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SecondOdcHandlingTime", {
      title: "2nd ODC Handling Time",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SecondOdcOutboundDay", {
      title: "2nd ODC Outbound Day",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SecondOdcEtd", {
      title: "2nd ODC ETD",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("SecondOdcTrainFerry", {
      title: "2nd ODC Train / Ferry",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ThirdOdcInbound", {
      title: "Inbound Route 3rd ODC",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ThirdOdcShortName", {
      title: "3rd ODC",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ThirdOdcCarrierName", {
      title: "3rd ODC Carrier Name",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ThirdOdcCarrierGsdb", {
      title: "3rd ODC Carrier GSDB",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ThirdOdcCarrierBranch", {
      title: "3rd ODC Carrier Branch",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ThirdOdcArrivalDay", {
      title: "3rd ODC Arrival Day",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ThirdOdcEta", {
      title: "3rd ODC ETA",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ThirdOdcHandlingTime", {
      title: "3rd ODC Handling Time",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ThirdOdcOutboundDay", {
      title: "3rd ODC Outbound Day",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ThirdOdcEtd", {
      title: "3rd ODC ETD",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ThirdOdcTrainFerry", {
      title: "3rd ODC Train / Ferry",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FourthOdcInbound", {
      title: "Inbound Route 4th ODC",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FourthOdcShortName", {
      title: "4th ODC",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FourthOdcCarrierName", {
      title: "4th ODC Carrier Name",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FourthOdcCarrierGsdb", {
      title: "4th ODC Carrier GSDB",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FourthOdcCarrierBranch", {
      title: "4th ODC Carrier Branch",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FourthOdcArrivalDay", {
      title: "4th ODC Arrival Day",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FourthOdcEta", {
      title: "4th ODC ETA",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FourthOdcHandlingTime", {
      title: "4th ODC Handling Time",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FourthOdcOutboundDay", {
      title: "4th ODC Outbound Day",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FourthOdcEtd", {
      title: "4th ODC ETD",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FourthOdcTrainFerry", {
      title: "4th ODC Train / Ferry",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FifthOdcInbound", {
      title: "Inbound Route 5th ODC",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FifthOdcShortName", {
      title: "5th ODC",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FifthOdcCarrierName", {
      title: "5th ODC Carrier Name",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FifthOdcCarrierGsdb", {
      title: "5th ODC Carrier GSDB",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FifthOdcCarrierBranch", {
      title: "5th ODC Carrier Branch",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FifthOdcArrivalDay", {
      title: "5th ODC Arrival Day",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FifthOdcEta", {
      title: "5th ODC ETA",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FifthOdcHandlingTime", {
      title: "5th ODC Handling Time",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FifthOdcOutboundDay", {
      title: "5th ODC Outbound Day",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FifthOdcEtd", {
      title: "5th ODC ETD",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FifthOdcTrainFerry", {
      title: "5th ODC Train / Ferry",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("InboundToPlantInbound", {
      title: "Inbound Route to Plant",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("InboundToPlantCarrierName", {
      title: "Inbound to Plant Carrier Name",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("InboundToPlantcCarrierGsdb", {
      title: "Inbound to Plant Carrier GSDB",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("InboundToPlantCarrierBranch", {
      title: "Inbound To Plant Carrier Branch",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("FullDayTT", {
      title: "Inbound to Plant Arrival Day (Full Day TT)",
      filter: "numeric",
      filterCell: (props) => customDecimalFilterCell(props, "#"),
      width: "300px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("InboundToPlantEta", {
      title: "Inbound to Plant ETA",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("InboundToPlantTrainFerry", {
      title: "Inbound to Plant Train / Ferry",
      width: "250px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("CMMS3TT", {
      title: "CMMS3 TT",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("DecimalTT", {
      title: "Decimal TT",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("OverrideTT", {
      title: "Override TT",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("OverrideTTRemark", {
      title: "Override TT Remark",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("OverrideTTInDate", {
      title: "Override TT Effective In Date",
      filter: "date",
      cell: kendoDateCell(onRowClick, "-"),
      width: "250px",
    }),
    columnForField<SpdrOverviewItem>("OverrideTTOutDate", {
      title: "Override TT Effective Out Date",
      filter: "date",
      cell: kendoDateCell(onRowClick, "-"),
      width: "250px",
    }),
    columnForField<SpdrOverviewItem>("OverrideCode", {
      title: "Override Code",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("EngineeredSF", {
      title: "Engineered SF",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("CMMS3SF", {
      title: "CMMS3 SF",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("PartExceptionRequired", {
      title: "Part Exception Required",
      filter: "boolean",
      cell: exceptionRequiredCell,
      columnMenu: YesNoColumnMenu,
      width: "200px",
      hideFilterCell: true,
    }),
    columnForField<SpdrOverviewItem>("InboundMLDM", {
      title: "Inbound MLDM",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("InboundELDM", {
      title: "Inbound ELDM",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("InboundKg", {
      title: "Inbound kg",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("InboundM3", {
      title: "Inbound m3",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ReturnMLDM", {
      title: "Return MLDM",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ReturnELDM", {
      title: "Return ELDM",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ReturnKg", {
      title: "Return kg",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ReturnM3", {
      title: "Return m3",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("ContainerType", {
      title: "Container Type",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("LtlKmTo1stOdc", {
      title: "LTL km to 1st ODC",
      filter: "numeric",
      width: "200px",
      cell: ValueOrDashCell,
    }),
    columnForField<SpdrOverviewItem>("TotalSpdrKm", {
      title: "Total SPDR km",
      filter: "numeric",
      width: defaultColumnWidth,
      cell: ValueOrDashCell,
    }),
  ];
}
